// write a hooks skeleton

import { getStepper } from '@app/screens/VerifyBankAccount/services/verifyBankService';
import { getApplicationId } from '@app/screens/FetchPortfolio/utils';
import { useAppDispatch, useAppSelector } from '@app/store/hooks';
import { RootState } from '@app/store/newstore';
import { showErrorSheet } from '@app/store/slices/errorSlice';
import { useIsFocused } from '@react-navigation/native';
import { useCallback, useEffect, useState } from 'react';



export const useStepperData = () => {

    const [stepperData, setStepperData] = useState<any>(null);
    const [isLoading, setIsLoading] = useState(true);
    const userDetails = useAppSelector((state: RootState) => state.auth.userDetails);
    const dispatch = useAppDispatch();
    const isFocused = useIsFocused();

    const getStepperData = useCallback(async () => {
        setIsLoading(true);
        try {
          const applicationId = await getApplicationId(userDetails?.linkedApplications[0]?.applicationId);
          const response = await getStepper({ applicationId: applicationId });
          setStepperData(response);
        } catch (error: any) {
          dispatch(showErrorSheet({
            isErrorSheetVisible: true,
            errorMessage: error?.data?.message,
            closeOnBackdropPress: true,
            errorType: error?.data?.voltErrorCode || error?.data?.statusCode,
          }));
        } finally {
            setIsLoading(false);
        }
      }, [userDetails]);

    useEffect(() => {
        isFocused && getStepperData();
    }, [isFocused]);

    return { stepperData, isLoading };
}
